// extracted by mini-css-extract-plugin
export default {"pushContainer":"push_pushContainer__ml5sG","pushStatus":"push_pushStatus__0dPa5","pushStatusBtn":"push_pushStatusBtn__5Srjs","removeSub":"push_removeSub__1N-O8"};